import { render, staticRenderFns } from "./RenewalsFilter.vue?vue&type=template&id=3393afca&"
import script from "./RenewalsFilter.vue?vue&type=script&lang=js&"
export * from "./RenewalsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports